/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 * 
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import { store } from "state";
import {
  rolesFailed,
  rolesLoading,
  rolesSuccess,
} from "state/redux/actions/RolesActions";
import { FetchError, FetchSuccess, fetchV2, toJSON } from "..";

export const getRoles = async () => {
  try {
    store.dispatch(rolesLoading());
    const response = await fetchV2(`admin-roles`, null, {
      page: "admins",
    });
    const roles = await toJSON(response);
    store.dispatch(rolesSuccess(roles, "roles"));
    return new FetchSuccess(response);
  } catch (res) {
    store.dispatch(rolesFailed());
    throw new FetchError(res, "Failed to get roles.");
  }
};

export const getRolesSelects = async () => {
  try {
    const res = await fetchV2(`admin-roles-to-select`);
    return new FetchSuccess(res);
  } catch (res) {
    throw new FetchError(res, "Failed to get roles");
  }
}

export const getRole = async (id) => {
  try {
    const response = await fetchV2(`admin-roles/${id}`, null, {
      page: "admins",
    });
    return new FetchSuccess(response);
  } catch (res) {
    throw new FetchError(res, "Failed to get role.");
  }
};

export const createRole = async (data) => {
  try {
    const response = await fetchV2(
      `admin-roles`,
      {
        method: "POST",
        body: JSON.stringify(data),
      },
      { page: "admins" }
    );
    await getRoles();
    return new FetchSuccess(response, "Role created successfully.");
  } catch (res) {
    throw new FetchError(res, "Failed to create role.");
  }
};

export const updateRole = async (id, data) => {
  try {
    const response = await fetchV2(
      `admin-roles/${id}`,
      {
        method: "PATCH",
        body: JSON.stringify(data),
      },
      { page: "admins" }
    );
    await getRoles();
    return new FetchSuccess(response, "Role updated successfully.");
  } catch (res) {
    throw new FetchError(res, "Failed to update role.");
  }
};

export const deleteRole = async (id) => {
  try {
    const response = await fetchV2(
      `admin-roles/${id}`,
      {
        method: "DELETE",
      },
      { page: "admins" }
    );
    await getRoles();
    return new FetchSuccess(response, "Role deleted successfully.");
  } catch (res) {
    throw new FetchError(res, "Failed to delete role.");
  }
};

export const getPages = async () => {
  try {
    const response = await fetchV2(`pages`, null, {
      page: "admins",
    });
    const data = await toJSON(response);
    store.dispatch(rolesSuccess(data, "pages"));
    return new FetchSuccess(response);
  } catch (res) {
    throw new FetchError(res, "Failed to get pages.");
  }
};
